// import JPC_LUKE from "../../../assets/images/raster/pages/main/Partners/luke.jpg";
import JPC_2X_LUKE from "../../../assets/images/raster/components/Partners/luke@2x.jpg";

// import JPC_JOIE from "../../../assets/images/raster/pages/main/Partners/joie.jpg";
import JPC_2X_JOIE from "../../../assets/images/raster/components/Partners/joie@2x.jpg";

// import JPC_ANDRE from "../../../assets/images/raster/pages/main/Partners/andre.jpg";
import JPC_2X_ANDRE from "../../../assets/images/raster/components/Partners/andre@2x.jpg";

// import JPC_JANSON from "../../../assets/images/raster/pages/main/Partners/janson.jpg";
import JPC_2X_JANSON from "../../../assets/images/raster/components/Partners/janson@2x.jpg";
import { URL_LABEL } from "../index.content";

export const SLIDER_CONFIG = {
  className: "PgESM-P-slider",
  centerMode: true,
  infinite: false,
  arrows: false,
  initialSlide: 0,
  speed: 500,
  touchThreshold: 40,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  dots: true,
};

const LUKE = {
  screen: {
    // JPG: JPC_LUKE,
    JPG_2X: JPC_2X_LUKE,
  },
  path: `/blog/how-to-make-10k-a-month/?${URL_LABEL}`,
  name: "Luke Wechselberger",
  position: "un vendedor de seis cifras y YouTuber",
  resultsBefore: "$5.000/mes",
  resultsWithUs: "$10.000/mes",
  profit: "+ $5.000",
};

const JOIE = {
  screen: {
    // JPG: JPC_JOIE,
    JPG_2X: JPC_2X_JOIE,
  },
  path: `/blog/is-selling-on-amazon-profitable/?${URL_LABEL}`,
  name: "Joie Roberts",
  position: "un vendedor de siete cifras y coach",
  resultsBefore: "$0/mes",
  resultsWithUs: "$2.000,000/año",
  profit: "+ $2.000,000",
};

const ANDRE = {
  screen: {
    // JPG: JPC_ANDRE,
    JPG_2X: JPC_2X_ANDRE,
  },
  path: `/blog/how-to-build-a-brand/?${URL_LABEL}`,
  name: "Andre Calzone",
  position: "un vendedor de marca privada y mentor",
  resultsBefore: "Empleado a tiempo completo en trabajo tradicional de 9 a 5",
  resultsWithUs: "Propietario de 4 negocios rentables",
  profit: "+ 4 empresas en línea",
};

const JANSON = {
  screen: {
    // JPG: JPC_JANSON,
    JPG_2X: JPC_2X_JANSON,
  },
  path: `/blog/amazon-fba-for-beginners/?${URL_LABEL}`,
  name: "Janson Smith",
  position: "un vendedor de siete cifras y YouTuber",
  resultsBefore: "Solo tenía $3.500 para inversión",
  resultsWithUs: "Ganó $20.000 de ganancia después de vender por 3 meses",
  profit: "+ $20.000",
};

export const POSTS = [LUKE, JOIE, ANDRE, JANSON];